// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1BQF-","select":"Header_select__3574-","clinic":"Header_clinic__1MEss"};